
<template>

    <div id="camaraGaleria">

        <h2 class="camaraGaleria-text">{{tryonTraducciones.tryon_title_camera_galeria}}</h2>

        <div class="camaraGaleria-btns">
            
            <v-touch class="camaraGaleria-btns-content" @tap="$emit('on-camera')">

                <div class="circle-btn"><img :src="baseURL+'/modules/supercheckout/images/camara.png'" ></div>
                
                <span class="btns-content-title">{{tryonTraducciones.tryon_icon_camara}}</span>

            </v-touch>

            <div class="camaraGaleria-btns-content">
                <label class="control-localImage">
                    <div class="circle-btn"><img :src="baseURL+'/modules/supercheckout/images/galeria.png'" ></div>
                    <input class="camara-galeria-input" type="file"/>
                </label>
                <span class="btns-content-title" >{{tryonTraducciones.tryon_icon_galeria}}</span>
            </div>

            

        </div>

    </div>

</template>


<script>

export default {

    data(){
        return {

            title: 'categorias',
            baseURL: baseURL,
            tryonTraducciones

        }
    },

    mounted: function () {

        const inputFile = $('.camara-galeria-input')

        const _this = this

        inputFile.change( function() {

            if (this.files && this.files[0]) {

                const reader = new FileReader()

                reader.onload = function (e) { 

                    _this.$emit('on-input', e.target.result )

                }

                reader.readAsDataURL(this.files[0])

            }

        })
        
    }
}

</script>



<style lang="scss">

    #camaraGaleria{
        padding: 20px;
        margin: 20px 0px;

        border-radius: 40px;
        border: 2px solid #ed3a5b;

        width: 90%;
        max-width: 425px;

        .camaraGaleria-text {
            margin: 20px auto;
            text-align: center;
            font-size: 21px;
        }

        .camaraGaleria-btns-content{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .btns-content-title{
                padding: 10px 0;
                font-size: 16px;
                text-transform: uppercase;
            }

        }

        .camaraGaleria-btns{

            display: flex;
            justify-content: space-around;

        }

        label.control-localImage input {
            display: none;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/CamaraGaleria.vue